jQuery(function ($) {
    /**
     * ヘッダー
     */
    /* ヘッダー固定 */
    $(window).scroll(function () {
        var h = $(this).scrollTop();
        if (h > 100) {
            $('#site-header').addClass('site-header-fixed');
        } else {
            $('#site-header').removeClass('site-header-fixed');
        }

    });

    (function ($) {
        if (window.matchMedia('(min-width: 1025px)').matches) {
            /* ヘッダーホバーリスト */
            $('.site-header__pitem').hover(function () {
                $(this).children('.site-header__clist').slideToggle(200);
            });
            //ウィンドウサイズが768以下の場合の処理
        } else {
            $('.site-header__pitem').click(function () {
                $(this).children('.site-header__clist').slideToggle(200);
                $(this).toggleClass('clicked');
            });
        }
    })(jQuery);

    $('.sp-menu').click(function () {
        $('#site-header__nav').slideToggle(200);
    })

    $('.sp-menu-close').click(function () {
        $('#site-header__nav').slideUp(200);
    })

    $('.voice-slider').slick({
        infinite: true,
        autoplay: true,  //TODO: autoplay有効化
        autoplaySpeed: 2000,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    variableWidth: false
                }
            }
        ]
    });

    //よくある質問アコーディオン
    $(".qa-list__item").click(function () {
        $(this).toggleClass("clicked");
        $(this).children('.qa-list__a').toggle("fast");
    });


    var headerHeight = $('#site-header').outerHeight();
    var urlHash = location.hash;
    if (urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function () {
            var target = $(urlHash);
            var position = target.offset().top - headerHeight;
            $('body,html').stop().animate({ scrollTop: position }, 600); // スクロールの速さ
        }, 100);
    }
    $('a[href^="#"]').click(function () {
        var href = $(this).attr("href");
        var target = $(href);
        var position = target.offset().top - headerHeight;
        $('body,html').stop().animate({ scrollTop: position }, 600); // スクロールの速さ
    });

    $('.cate-selecter').on('change', function () {
        var $this = $(this)
        var $option = $this.find('option:selected');
        $('.cate-selecter__label').text($option.text());

        $this.blur();

    });
});
